import React from "react";

function BS4_JS_Popover() {
  return (
    <div>
      <h1>BS4_JS_Popover Component</h1>
      <p>This is the BS4_JS_Popover tutorial page content.</p>
    </div>
  );
}

export default BS4_JS_Popover;
